import { BaseModel } from '../../_base/crud';

export class GrainType extends BaseModel{
    id: number;
    name: string;
    clear(){
        this.name   = "";
        this.id     = undefined;
    }
}